import { Helmet } from 'react-helmet-async';
import { Box, Typography } from '@mui/material';
import Wrapper from 'src/components/common/wrapper';
import SigninForm from 'src/components/form/SigninForm';
import { Link } from 'react-router-dom';
import { t } from 'i18next';

const SigninPage = () => {
  return (
    <Wrapper>
      <Helmet>
        <title>JMC </title>
      </Helmet>
      <Box
        component="img"
        src="/logo.jpeg"
        alt="logo"
        sx={{
          height: '200px',
          width: '200px',
          mixBlendMode: 'multiply',
          mt: { md: 0, xs: '2rem' },
        }}
      />
      <Typography sx={{ mb: 3, textAlign: 'center' }} variant="h4" color={'primary'}>
        {t('signinPage.heading')}
      </Typography>
      <SigninForm />
      <Typography variant="h8" sx={{ my: 3 }}>
        {t('signinPage.noAccount')}{' '}
        <Link to={'/sign-up'} style={{ color: '#ACD644', textDecoration: 'none' }}>
          {t('signinPage.signup')}
        </Link>
      </Typography>
      <Typography variant="h8">
        <Link to={'/privacy-policy'} style={{ color: '#ACD644', textDecoration: 'none' }}>
          {t('signinPage.policy')}
        </Link>
      </Typography>
    </Wrapper>
  );
};

export default SigninPage;
